/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs */

const en_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual hours saved`)
};

const ar_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعات يدوية موفرة`)
};

const bn_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাশ্রয়ী ম্যানুয়াল ঘণ্টা`)
};

const de_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Stunden gespart`)
};

const es_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas manuales guardadas`)
};

const fr_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures manuelles économisées`)
};

const pt_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas manuais salvas`)
};

const zh_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省的手动时间`)
};

const tr_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuel çalışma saatleri kaydedildi`)
};

const ru_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сэкономлено часов вручную`)
};

const pl_svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisano godziny ręczne`)
};

/**
* | output |
* | --- |
* | "Manual hours saved" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_work_0_metric_2_label = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Work_0_Metric_2_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
	return en_svc_ecommerce_amazon_tools_work_0_metric_2_label(inputs)
});
export { svc_ecommerce_amazon_tools_work_0_metric_2_label as "svc_ecommerce-amazon-tools_work_0_metric_2_label" }